import React from 'react';
import { FiFacebook, FiInstagram, FiLinkedin } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal text-white pt-16 pb-8 border-t-[8px] border-gold">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12 border-b border-white/10 pb-12">
          
          {/* Brand Col */}
          <div className="lg:col-span-1">
            <a href="#home" className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 bg-gold rounded flex items-center justify-center text-white font-serif font-bold text-xl">
                E
              </div>
              <span className="font-serif font-bold text-xl text-white tracking-tight">
                EPO Valuation
              </span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Credible, Timely Appraisals for Residential & Commercial Properties Across Texas.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-300 hover:bg-gold hover:text-white transition-all">
                <SafeIcon icon={FiFacebook} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-300 hover:bg-gold hover:text-white transition-all">
                <SafeIcon icon={FiInstagram} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-300 hover:bg-gold hover:text-white transition-all">
                <SafeIcon icon={FiLinkedin} />
              </a>
            </div>
          </div>

          {/* Links Quick */}
          <div>
            <h4 className="font-serif font-bold text-lg mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'About', 'Services', 'How It Works'].map((item) => (
                <li key={item}>
                  <a href={`#${item.toLowerCase().replace(/ /g, '-')}`} className="text-gray-400 hover:text-gold transition-colors text-sm flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-gold"></span> {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Links More */}
          <div>
            <h4 className="font-serif font-bold text-lg mb-6 text-white">Resources</h4>
            <ul className="space-y-3">
              {['FAQ', 'Contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item.toLowerCase()}`} className="text-gray-400 hover:text-gold transition-colors text-sm flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-gold"></span> {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Col */}
          <div>
            <h4 className="font-serif font-bold text-lg mb-6 text-white">Contact Info</h4>
            <ul className="space-y-4">
              <li>
                <p className="text-xs text-gray-500 uppercase tracking-wider font-bold mb-1">Phone</p>
                <a href="tel:+12148854504" className="text-white hover:text-gold transition-colors text-lg font-serif">+1-214-885-4504</a>
              </li>
              <li>
                <p className="text-xs text-gray-500 uppercase tracking-wider font-bold mb-1">Location</p>
                <p className="text-gray-300 text-sm">Dallas, Texas</p>
              </li>
            </ul>
          </div>

        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
          <p className="text-sm text-gray-500">
            © {currentYear} EPO Valuation. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;